import { z } from 'zod';

const askEvoResultSchema = z.object({
  usable: z.boolean(),
  reason: z.string().nullish(),
  answer: z.string().nullish(),
  follow_ups: z.array(z.string()).default([]),
  window: z.string().nullish(),
  caveats: z.array(z.string()).default([]),
  truncated: z.boolean().default(false),
  synthesis_failed: z.boolean().default(false),
  matched_workflow: z.string().nullish(),
  matched_workflow_entry_points: z.array(z.string()).default([]),
});

export type AskEvoResult = z.infer<typeof askEvoResultSchema>;

export function parseAskEvo(result: unknown): AskEvoResult | null {
  const parsed = askEvoResultSchema.safeParse(result);
  if (!parsed.success) return null;
  return parsed.data;
}
